export default __webpack_public_path__ + "static/media/support.08c15738.svg";